import ag_grid_headers from './en-US/ag_grid_headers';
import antd_fields from './en-US/antd_fields';
import common from './en-US/common';
import contacts_pages from './en-US/contacts_pages';
import errors from './en-US/errors';
import menu from './en-US/menu';
import pages from './en-US/pages';
import success from './en-US/success';

export default {
    'navBar.lang': 'Languages',
    'layout.user.link.help': 'Help',
    'layout.user.link.privacy': 'Privacy',
    'layout.user.link.terms': 'Terms',
    'app.copyright.produced': 'Produced by ESIG SH.A.',
    'app.preview.down.block': 'Download this page to your local project',
    'app.welcome.link.fetch-blocks': 'Get all block',
    'app.welcome.link.block-list': 'Quickly build standard, pages based on `block` development',
    'component.read-more': 'Read More',
    'app.pwa.offline': 'You are offline now',
    'app.pwa.serviceworker.updated': 'New content is available',
    'app.pwa.serviceworker.updated.hint': 'Please press the "Refresh" button to reload current page',
    'app.pwa.serviceworker.updated.ok': 'Refresh',
    'app.not_translated': 'Not Translated',
    ...pages,
    ...menu,
    ...common,
    ...ag_grid_headers,
    ...antd_fields,
    ...contacts_pages,
    ...errors,
    ...success,
};
